import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import { getLinkGroupApi, getLinkDataApi, getLinkBlobApi } from '@/api';
import { dbDataHandle } from '@/store/function/common';

import { mapState, mapMutations } from 'vuex';
import { DateTime } from 'luxon';
export default {
  name: 'TvScreen',
  data: function data() {
    return {
      animationON: false,
      photoload: false,
      singleFactory: true,
      lockText: '案場鎖定',
      lock: false,
      animation: false,
      imglist: [],
      sliderValue: 0,
      linkData: {},
      factoryName: '',
      time: '',
      systemTime: '',
      timer: null,
      reload: null,
      infoArray: [],
      sliderInfo: {},
      sliderInfoCount: 0,
      slider: null,
      groupDataArray: [],
      linkPhotoArray: [],
      moduleTempTitleHeight: 80
    };
  },
  computed: _objectSpread({}, mapState(['factoryInfo', 'querySiteName'])),
  methods: _objectSpread(_objectSpread({}, mapMutations(['ADD_QUERY_SITE_NAME'])), {}, {
    dbDataHandle: dbDataHandle,
    handleIrr: function handleIrr(value) {
      return !(value === undefined || value.length === 0 || value === null);
    },
    changeIndex: function changeIndex(index) {
      this.sliderValue = index;
    },
    sliderCount: function sliderCount(string) {
      var _this = this;
      this.animationON = true;
      if (string === 'plus') {
        this.sliderInfoCount = this.sliderInfoCount + 1;
        this.animation = !this.animation;
      }
      if (string === 'minus') {
        if (this.sliderInfoCount > 0) {
          this.sliderInfoCount = this.sliderInfoCount - 1;
          this.animation = !this.animation;
        }
      }
      setTimeout(function () {
        _this.infoChange();
      }, 700);
    },
    lockSlider: function lockSlider() {
      this.lock = !this.lock;
      this.lockText = this.lock ? '啟動輪播' : '案場鎖定';
    },
    getLinkGroup: function getLinkGroup() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _groupData$data, groupData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.$route.query.groupNumber === '0')) {
                  _context.next = 9;
                  break;
                }
                _this2.singleFactory = true;
                _this2.lock = true;
                _this2.groupDataArray[0] = [];
                _this2.groupDataArray[0].factoryId = _this2.$route.query.fid;
                _this2.groupDataArray[0].factoryName = _this2.querySiteName;
                _this2.groupDataArray[0].sysTimeStartFrom = _this2.$route.query.systemTime;
                _context.next = 13;
                break;
              case 9:
                _context.next = 11;
                return getLinkGroupApi(_this2.$route.query.groupNumber);
              case 11:
                groupData = _context.sent;
                if (groupData !== null && groupData !== void 0 && (_groupData$data = groupData.data) !== null && _groupData$data !== void 0 && _groupData$data.success) {
                  _this2.groupDataArray = groupData.data.data.sort(function (a, b) {
                    return a.factoryId - b.factoryId;
                  });
                  _this2.singleFactory = false;
                }
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getLink: function getLink() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var infoArray, i, id, factoryName, systemTime, finalObject, _linkData$data, _linkData$data2, linkData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                infoArray = [];
                i = 0;
              case 2:
                if (!(i < _this3.groupDataArray.length)) {
                  _context2.next = 25;
                  break;
                }
                // slider 好了再打開
                id = _this3.groupDataArray[i].factoryId;
                factoryName = _this3.groupDataArray[i].factoryName;
                systemTime = _this3.groupDataArray[i].sysTimeStartFrom;
                finalObject = {};
                _context2.prev = 7;
                _context2.next = 10;
                return getLinkDataApi(factoryName, id, DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM'));
              case 10:
                linkData = _context2.sent;
                if (linkData !== null && linkData !== void 0 && (_linkData$data = linkData.data) !== null && _linkData$data !== void 0 && _linkData$data.data) {
                  finalObject = linkData.data.data;
                }
                if (linkData !== null && linkData !== void 0 && (_linkData$data2 = linkData.data) !== null && _linkData$data2 !== void 0 && _linkData$data2.msg) {
                  finalObject.msg = linkData.data.msg;
                }
                finalObject.site = factoryName;
                finalObject.time = DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss');
                finalObject.systemTime = systemTime;
                infoArray.push(finalObject);
                _context2.next = 22;
                break;
              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](7);
                console.log('getLinkDataApi error', _context2.t0);
              case 22:
                i++;
                _context2.next = 2;
                break;
              case 25:
                _this3.infoArray = JSON.parse(JSON.stringify(infoArray));
                _this3.infoChange();
              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[7, 19]]);
      }))();
    },
    getPhoto: function getPhoto() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var j, isDemoName, querySiteFid, linkPhoto, i, a;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.linkPhotoArray = [];
                j = 0;
              case 2:
                if (!(j < _this4.groupDataArray.length)) {
                  _context3.next = 12;
                  break;
                }
                isDemoName = _this4.$route.query.siteName.includes('展示案場 ');
                querySiteFid = isDemoName ? 'f000' : _this4.groupDataArray[j].factoryId;
                _context3.next = 7;
                return getLinkBlobApi(querySiteFid);
              case 7:
                linkPhoto = _context3.sent;
                if (linkPhoto.data.data.length > 0) {
                  _this4.linkPhotoArray[j] = [];
                  for (i = 0; i < linkPhoto.data.data.length; i++) {
                    a = {
                      imgsrc: linkPhoto.data.data[i]
                    };
                    _this4.linkPhotoArray[j].push(a);
                  }
                }
              case 9:
                j++;
                _context3.next = 2;
                break;
              case 12:
                if (_this4.linkPhotoArray.every(function (arr) {
                  return !!arr.length;
                })) {
                  _this4.photoload = true;
                }
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    infoChange: function infoChange() {
      var infoLen = this.infoArray.length;
      if (this.sliderInfoCount >= infoLen) {
        this.sliderInfoCount = 0;
      }
      this.sliderInfo = this.infoArray[this.sliderInfoCount];
      this.imglist = this.linkPhotoArray[this.sliderInfoCount];
    },
    tvInterval: function tvInterval() {
      var _this5 = this;
      this.timer = setInterval(function () {
        _this5.getLink();
      }, 60000);
      this.slider = setInterval(function () {
        if (!_this5.lock) {
          _this5.sliderInfoCount = _this5.sliderInfoCount + 1;
          _this5.animationON = true;
          _this5.animation = !_this5.animation;
          setTimeout(function () {
            _this5.infoChange();
          }, 700);
        }
      }, 20000);
    },
    clearTvInterval: function clearTvInterval() {
      clearInterval(this.timer);
      clearInterval(this.slider);
      this.timer = null;
      this.slider = null;
    },
    handleResize: function handleResize() {
      var _this6 = this;
      this.$nextTick(function () {
        _this6.moduleTempTitleHeight = _this6.$refs.refCo2Title.getBoundingClientRect().height;
      });
    }
  }),
  mounted: function mounted() {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this7.moduleTempTitleHeight = _this7.$refs.refCo2Title.getBoundingClientRect().height;
              window.addEventListener('resize', _this7.handleResize);
              _this7.ADD_QUERY_SITE_NAME(_this7.$route.query.siteName);
              _context4.next = 5;
              return _this7.getLinkGroup();
            case 5:
              _context4.next = 7;
              return _this7.getLink();
            case 7:
              _context4.next = 9;
              return _this7.getPhoto();
            case 9:
              _this7.infoChange();
              _this7.tvInterval();
              _this7.reload = setInterval(function () {
                _this7.clearTvInterval();
                _this7.tvInterval();
              }, 3600000);
            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.reload);
    clearInterval(this.slider);
    this.slider = null;
    this.timer = null;
    this.reload = null;
    window.removeEventListener('resize', this.handleResize);
  }
};